// Payment provider / currency selection.
// Non-India visitors default to Stripe (USD); India defaults to Razorpay (INR).
// The choice is auto-detected from the browser but the user can override it with a
// toggle; the override is remembered for the session.

export const PROVIDERS = {
  stripe:   { key: 'stripe',   currency: 'USD', symbol: '$',       label: 'USD', gateway: 'Stripe' },
  razorpay: { key: 'razorpay', currency: 'INR', symbol: '\u20B9', label: 'INR', gateway: 'Razorpay' },
};

// India → Razorpay/INR, everyone else → Stripe/USD.
export function detectProvider() {
  try {
    const tz = (Intl.DateTimeFormat().resolvedOptions().timeZone || '').toLowerCase();
    const lang = (navigator.language || '').toLowerCase();
    const isIndia = tz.includes('kolkata') || tz.includes('calcutta') || lang.endsWith('-in');
    return isIndia ? 'razorpay' : 'stripe';
  } catch (e) {
    return 'stripe';
  }
}

const KEY = 'riq_pay_provider';

export function getProvider() {
  try {
    const v = sessionStorage.getItem(KEY);
    if (v === 'stripe' || v === 'razorpay') return v;
  } catch (e) { /* ignore */ }
  return detectProvider();
}

export function setProvider(p) {
  try { sessionStorage.setItem(KEY, p); } catch (e) { /* ignore */ }
}
